import { capture, captureWithBeacon, sanitizePath } from "./posthog";

type Feature =
  | "copilot"
  | "payments"
  | "payment_plans"
  | "patients"
  | "documents"
  | "claims"
  | "reconciliation"
  | "insurance_ar"
  | "reports"
  | "credentials"
  | "verification"
  | "studio"
  | "other";

const FEATURE_BY_PREFIX: [string, Feature][] = [
  ["/copilot", "copilot"],
  ["/payments", "payments"],
  ["/patients/", "patients"],
  ["/patients", "patients"],
  ["/documents", "documents"],
  ["/claims", "claims"],
  ["/reconciliation", "reconciliation"],
  ["/insurance-ar", "insurance_ar"],
  ["/reports", "reports"],
  ["/credentials", "credentials"],
  ["/insurance-verification", "verification"],
  ["/studio", "studio"],
];

function featureFromPath(pathname: string): Feature {
  const path = pathname.toLowerCase();
  if (/^\/patients\/[^/]+\/payment-plans/.test(path)) {
    return "payment_plans";
  }
  const match = FEATURE_BY_PREFIX.find(([prefix]) => path.startsWith(prefix));
  return match ? match[1] : "other";
}

function trackAppLoaded(practiceCount: number): void {
  capture("app_loaded", { practice_count: practiceCount });
}

function trackPracticeFilterChanged(
  beforeCount: number,
  afterCount: number,
): void {
  capture("practice_filter_changed", {
    selected_practice_count_before: beforeCount,
    selected_practice_count_after: afterCount,
  });
}

function trackFeatureViewed(feature: Feature, pathname: string): void {
  capture("feature_viewed", {
    feature,
    path_template: sanitizePath(pathname),
  });
}

function trackFeatureTimeSpent(feature: Feature, durationMs: number): void {
  captureWithBeacon("feature_time_spent", {
    feature,
    duration_ms: durationMs,
  });
}

export type { Feature };
export {
  featureFromPath,
  trackAppLoaded,
  trackFeatureTimeSpent,
  trackFeatureViewed,
  trackPracticeFilterChanged,
};
